import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/inventario/inventarioSelectors';
import DrawerButton from 'src/view/shared/view/DrawerButton';
import InventarioView from '../view/InventarioView';

function InventarioListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerInventarioViewPage'}
          type={props.type || 'chip'}
          entity={'inventario'}
          tooltipTitle={i18n(record.titulo)}
          buttonTitle={i18n(record.titulo)}
          width={window.innerWidth * 0.55}
          record={record}
          component={<InventarioView record={record} drawer={true} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

InventarioListItem.propTypes = {
  value: PropTypes.any,
  type: PropTypes.string,
};

export default InventarioListItem;
